import { useEffect, useState } from "react";
import { Package, Star, Users, Layers } from "lucide-react";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Cell } from "recharts";
import { api } from "@/lib/api";

const CARDS = [
  { key: "products", label: "Total Products", icon: Package },
  { key: "featured_products", label: "Featured", icon: Star },
  { key: "artists", label: "Artists", icon: Users },
  { key: "categories", label: "Categories", icon: Layers },
];

export default function AdminOverview() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="admin-overview">
      <p className="font-mono-hw text-[11px] uppercase tracking-[0.25em] text-gavra">Dashboard</p>
      <h1 className="mt-2 font-heading text-4xl font-black uppercase tracking-tight md:text-5xl">Overview</h1>

      <div className="mt-8 grid grid-cols-2 gap-4 lg:grid-cols-4">
        {CARDS.map((c) => (
          <div key={c.key} data-testid={`stat-${c.key}`} className="border border-black/10 p-6">
            <c.icon className="h-6 w-6 text-gavra" />
            <p className="mt-4 font-heading text-4xl font-black">{stats ? stats[c.key] : "—"}</p>
            <p className="mt-1 font-mono-hw text-[10px] uppercase tracking-widest text-black/40">{c.label}</p>
          </div>
        ))}
      </div>

      <div className="mt-8 border border-black/10 p-6">
        <p className="font-heading text-xl font-bold uppercase tracking-tight">Products by Category</p>
        <div className="mt-6 h-72">
          {stats?.by_category?.length > 0 ? (
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={stats.by_category} margin={{ top: 5, right: 10, left: -20, bottom: 40 }}>
                <XAxis dataKey="category" angle={-30} textAnchor="end" interval={0} tick={{ fontSize: 11, fill: "#555" }} axisLine={{ stroke: "#0a0a0a" }} tickLine={false} />
                <YAxis allowDecimals={false} tick={{ fontSize: 11, fill: "#555" }} axisLine={false} tickLine={false} />
                <Bar dataKey="count" radius={[0, 0, 0, 0]}>
                  {stats.by_category.map((_, i) => (
                    <Cell key={i} fill={i % 2 === 0 ? "#FF5A00" : "#0a0a0a"} />
                  ))}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          ) : (
            <div className="flex h-full items-center justify-center text-sm text-black/40">No data yet</div>
          )}
        </div>
      </div>
    </div>
  );
}
